import { fontSize, grid, maxBreakpoints, minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, smallElevation, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { commonHeading } from "./common.styles";
var spacing = theme.spacing,
  text = theme.text;
var PANEL_OFFSET = spacing.lg;
export var partner = /*#__PURE__*/css(["", ";grid-auto-rows:min-content;grid-column:auto / span 12;transform:translateY(-", ");border-bottom:1px solid var(--neutral-black-30);padding-bottom:", ";&:last-child{border:none;padding:0;}", " ", " ", ""], grid, pxToRem(PANEL_OFFSET), pxToRem(spacing.xxl), mediaQuery({
  min: minBreakpoints.M
}, css(["grid-column:auto / span 6;display:flex;flex-direction:column;border:none;padding:0;"])), mediaQuery({
  min: minBreakpoints.L
}, css(["grid-row-gap:", ";"], pxToRem(spacing.xxl))), mediaQuery({
  min: minBreakpoints.XL
}, css(["display:grid;"])));
export var partnerImageContainer = /*#__PURE__*/css(["grid-column:1 / span 12;", ";", ""], grid, mediaQuery({
  min: minBreakpoints.XL
}, css(["grid-column:1 / span 6;"])));
export var partnerCopyContainer = /*#__PURE__*/css(["", ";grid-column:1 / span 12;", " ", ""], grid, mediaQuery({
  min: minBreakpoints.M
}, css(["flex:1;"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["margin-top:", ";grid-column:auto / span 6;"], pxToRem(spacing.xl + PANEL_OFFSET))));
export var partnerCopyContent = /*#__PURE__*/css(["grid-column:1 / span 12;", " ", ""], mediaQuery({
  min: minBreakpoints.M,
  max: maxBreakpoints.L
}, css(["grid-column:1 / span 10;"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["padding-right:", ";"], pxToRem(spacing.xl))));
export var partnerHeading = /*#__PURE__*/css(["", " margin:", ";"], commonHeading, stack(spacing.xl));
export var partnerCopy = /*#__PURE__*/css(["", " margin:", ";"], fontSize(text.BODY.SM), stack(spacing.xl));
export var partnerCta = /*#__PURE__*/css(["", ";", ";color:var(--neutral-black-base);"], primarySemiBoldFont, fontSize(text.BODY.SM));
export var partnerImage = /*#__PURE__*/css(["display:block;width:100%;height:auto;border-radius:", ";overflow:hidden;", ";grid-column:1 / span 9;", " ", " ", ""], pxToRem(10), smallElevation, mediaQuery({
  min: minBreakpoints.M
}, css(["grid-column:1 / span 8;"])), mediaQuery({
  min: minBreakpoints.L
}, css(["grid-column:1 / span 6;"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["grid-column:1 / span 12;"])));
export var productsContainer = /*#__PURE__*/css(["grid-column:1 / span 12;", ";"], grid);
export var product = /*#__PURE__*/css(["grid-column:auto / span 6;", " ", ""], mediaQuery({
  min: minBreakpoints.M
}, css(["&:first-child{grid-column:1 / span 5;}&:last-child{grid-column:auto / span 5;}"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["&:first-child{grid-column:3 / span 4;}&:last-child{grid-column:auto / span 4;}"])));